import placeholder from '@/packages/components/base/image/src/assets/img/placeholder.png'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-image', // 组件名
  type: 'component-base', // 组件类型
  label: '图片', // 组件label
  icon: 'icon-xy-image', // 组件图标
  defaultWidth: 750, // 组件默认宽度
  defaultHeight: 400 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  // 图片链接
  src: { type: String, default: placeholder },
  // 图片填充方式
  fit: { type: String, default: 'fill' }
}

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-upload-image', // 表单组件
    label: '图片', // 表单名称
    propKey: 'src', // 表单model字段名称
    isLanguage: true, // 是否可多语言配置
    isActivityData: true // 是否为动态数据
  },
  {
    type: 'xy-form-select', // 表单组件
    label: '缩放', // 表单名称
    propKey: 'fit', // 表单model字段名称
    options: [
      {
        label: '铺满',
        value: 'fill'
      },
      {
        label: '比例缩放',
        value: 'contain'
      },
      {
        label: '比例裁剪',
        value: 'cover'
      },
      {
        label: '原始大小',
        value: 'none'
      },
      {
        label: '自适应',
        value: 'scale-down'
      }
    ] // 选项
  }
]
